import type {PageRouteConfig} from '@router';

import PinDetails from 'modules/Services/PromotionCenter/Pin/Details/PinDetails';

export function createPromotionCenterPinDetailsRoute(): PageRouteConfig {
  return {
    element: <PinDetails />,
    layout: {
      title: 'جزئیات بسته',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
